import Cookies from "js-cookie";
import CONFIG from "@/app/config";
import AuthService from "@emcd-shared/auth-service";

const WALLET_HIDE_COOKIE = "isWalletHidden";

const APP_ENVIRONMENT = CONFIG.ENVIRONMENT;
const isProd = APP_ENVIRONMENT === "production";

export const ACCESS_TOKEN_COOKIE = `auth_${
  APP_ENVIRONMENT === "production" ? "" : APP_ENVIRONMENT
}_access_token`;

export const REFRESH_TOKEN_COOKIE = `auth_${
  APP_ENVIRONMENT === "production" ? "" : APP_ENVIRONMENT
}_refresh_token`;

function initState() {
  return {
    isBalanceHidden: !!Cookies.get(WALLET_HIDE_COOKIE),
    userData: null,
    isPossibleAuthorize:
      !!Cookies.get(ACCESS_TOKEN_COOKIE) && !!Cookies.get(REFRESH_TOKEN_COOKIE),
  };
}

const state = initState();

const mutations = {
  SET_USER_DATA(state, userData) {
    state.userData = userData;
  },
};

const actions = {
  async authenticate({ commit }) {
    try {
      const userData = await AuthService.authenticate();
      commit("SET_USER_DATA", userData);
    } catch (error) {
      try {
        await AuthService.refresh(this.$customApiService());
        const userData = await AuthService.authenticate();
        commit("SET_USER_DATA", userData);
      } catch (refreshError) {
        // The session can not be restored: auth-service has already cleared
        // it (login redirect is off in main.js), show the header as a guest.
        commit("SET_USER_DATA", null);
        throw refreshError;
      }
    }
  },
  logout({ commit }) {
    commit("SET_USER_DATA", null);
    Cookies.remove(`auth_${isProd ? "" : APP_ENVIRONMENT}_access_token`, {
      domain: window.location.hostname,
    });
    Cookies.remove(`auth_${isProd ? "" : APP_ENVIRONMENT}_refresh_token`, {
      domain: window.location.hostname,
    });
  },
};

const getters = {
  getUserData: (state) => state.userData,
  getIsPossibleAuthorize: (state) => state.isPossibleAuthorize,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
